import axios        from "axios";
import {url_path}   from "./paths";


export default {
    state: {
        projects: [],
        deletedProjects: [],
        projects_loaded: false,
        current_project: { },
        last_project: { }
    },
    mutations: {
        setProjectsList (state, payload) {
            state.projects = payload;
            state.projects_loaded = true;
        },
        setDeletedProjectsList (state, payload) {
            state.deletedProjects = payload;
        },
        shareCurrentProject (state, payload) {
            const key = Object.keys(state.projects).find(k=>state.projects[k].hashid==payload.hashid);
            state.projects[key].is_shared = payload.is_shared;
            state.projects[key].shared_slug = payload.shared_slug;
            state.projects[key].shared_password = payload.shared_password;
        },
        getCurrentProject (state, hashid) {
            history.pushState({}, null, '/projects/' + hashid);
            state.current_project = state.projects.find(project => project.hashid === hashid);
        },
        setLastProject (state, payload) {
            state.last_project = payload;
        },
        updateLayerName (state, {name, hashid, id}) {
            const prjkey = Object.keys(state.projects).find(k=>state.projects[k].hashid===hashid);
            const lyrkey = Object.keys(state.projects).find(k=>state.projects[prjkey].layers[k].id===id);
            state.projects[prjkey].layers[lyrkey].name = name;
        },
    },
    actions: {
        async getProjects ({commit}) {
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.get(url_path.url_projects_list);
                if (response.data.status == url_path.response_status_ok){
                    commit('setProjectsList', response.data.data);
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async getDeletedProjects ({commit}) {
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.get(url_path.url_projects_list + '?show_only_removed=1');
                if (response.data.status == url_path.response_status_ok){
                    commit('setDeletedProjectsList', response.data.data);
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async deleteProject ({commit}, hashid){
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.get(url_path.url_projects_delete + hashid);
                if (response.data.status == url_path.response_status_ok){
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async deleteProjectPerm ({commit}, hashid){
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.get(url_path.url_projects_delete_perm + hashid + '?action=forcedelete');
                if (response.data.status == url_path.response_status_ok){
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async restoreProject ({commit}, hashid){
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.get(url_path.url_projects_restore + hashid + '?action=restore');
                if (response.data.status == url_path.response_status_ok){
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async addNewProject ({commit}, {name, description}){
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.post(url_path.url_projects_add, {name: name, description: description});
                if (response.data.status == url_path.response_status_ok){
                    commit('setLastProject', response.data.data);
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async updateNewProject ({commit}, {name, description, hashid}){
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.post(url_path.url_projects_edit + hashid, {name: name, description: description});
                if (response.data.status == url_path.response_status_ok){
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async shareNewProject ({commit}, {hashid, share, password}){
            commit('clearError');
            commit('setLoading', true);
            try {
            //    const response = await axios.get(url_path.url_projects_share + hashid);
                const response = await axios.post(url_path.url_projects_edit + hashid, {share, password});
                if (response.data.status == url_path.response_status_ok){
                    commit('shareCurrentProject', response.data.data);
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async unShareNewProject ({commit}, hashid){
            commit('clearError');
            commit('setLoading', true);

            try {
            //    const response = await axios.get(url_path.url_projects_unshare + hashid);
                const response = await axios.post(url_path.url_projects_edit + hashid, {share: 0});
                if (response.data.status == url_path.response_status_ok){
                    commit('shareCurrentProject', hashid);
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async setCurrentProject ({commit}, hashid) {
            await commit('getCurrentProject', hashid);
        },
        setActiveLayer ({commit}, {hashid, id}) {
            commit('setActiveLayer', {hashid, id});
        }
    },
    getters: {
        projects (state){
            return state.projects;
        },
        deleted_projects (state){
            return state.deletedProjects;
        },
        projectsLoaded (state){
            return state.projects_loaded;
        },
        peojectById (state) {
            return projectId => {
                return state.projects.find(project => project.hashid === projectId);
            }
        },
        currentProject (state) {
            return state.current_project;
        },
        getLastProject (state) {
            return state.last_project;
        },
        layers_count (state){
            return state.current_project.layers.length;
        },
    }
}
